module.exports = __webpack_public_path__ + "images/vanmeeuwen-workslip-220x60.63216b16d54bcccd25b4.png";